(function () {
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (isTouch) return; // disable on mobile

  let current = window.scrollY;
  let target = window.scrollY;
  const ease = 0.08;
  let isWheelScrolling = false;

  function getMaxScroll() {
    return document.documentElement.scrollHeight - window.innerHeight;
  }

  function rafScroll() {
    if (isWheelScrolling) {
      const max = getMaxScroll();
      target = Math.max(0, Math.min(target, max));

      current += (target - current) * ease;

      // Snap to target if very close
      if (Math.abs(target - current) < 0.5) {
        current = target;
        isWheelScrolling = false;
      }

      window.scrollTo(0, current);
    } else {
      // Keep current synced when user scrolls to top or bottom naturally
      current = window.scrollY;
      target = window.scrollY;
    }

    requestAnimationFrame(rafScroll);
  }

  window.addEventListener(
    'wheel',
    (e) => {
      e.preventDefault();
      target += e.deltaY;
      isWheelScrolling = true;
    },
    { passive: false }
  );

  rafScroll();
})();


window.addEventListener("scroll", function () {
  const header = document.querySelector(".main-collection-style1__header");

  if (window.scrollY > 100) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
});